import React from 'react';
import { Modal, Container, Row, Col, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classes from './RegistersModal.module.css';
import { convertDate, prefixCheck, prefixMailto, getCountryNamesFromSession, getRegistersQuery, API_URLS } from '../../shared/utility';
import CloseButton from '../UI/CloseButton/CloseButton';
import { IActiveRegisterContribution } from '../UI/Table/Table';
import graphQLClientInstance from '../../axios-graphql-client';

const RegistersModal = (props: any) => {
  const { t } = useTranslation();
  const [data, setData] = React.useState<IActiveRegisterModal|null>(null);

  React.useEffect(() => {
    if (props.show) {
      if (!props.data) {
        setData(null);
        const searchRegisterValues = {
          registerType: props.publicationtypeid,
          countryid: props.countryid,
          extraid: props.publicationextraid
        }
        graphQLClientInstance.post(API_URLS.GRAPHQL, getRegistersQuery(searchRegisterValues, 1, 0))
        .then(res => {
          if (res.data?.data?.registersSearch?.data) {
            const registerSearchData = res.data.data.registersSearch.data[0];
            setData(
              {
                ...registerSearchData
              }
            )
          }
        })
        .catch(err => {
          console.log(err);
        });
      } else {
        setData({
          publicationtypeid: props.publicationtypeid,
          countryid: props.countryid,
          publicationname: props.data.publicationname,
          name: props.data.name,
          websiteurl: props.data.websiteurl,
          remarks: props.data.remarks,
          email: props.data.email,
          addressformatted: props.data.addressformatted,
          all_contributions: props.data.all_contributions,
        })
      }
    }
  }, [props]);

  return (
    <Modal centered show={props.show} onHide={() => props.setShow(false)} size="lg">
      <Modal.Header className={classes.header}>
        <CloseButton onClick={() => props.setShow(false)} />
        <Modal.Title>{t("register")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={classes.body}>
      {data?(
        <Container>
            <Row>
              <Col md="3" className="mb-1">
                {t("register_name")}
              </Col>
              <Col md="9" className="mb-1">
                {data.publicationname}
              </Col>
              <Col md="3" className="mb-1">
                {t("register_type")}
              </Col>
              <Col md="9" className="mb-1">
                {data.publicationtypeid?t(`register_types.${data.publicationtypeid.toLowerCase()}`):""}
              </Col>
              <Col md="3" className="mb-1">
                {t("country")}
              </Col>
              <Col md="9" className="mb-1">
                {getCountryNamesFromSession(data.countryid)}
              </Col>
              <Col md="3" className="mb-1">
                {t("website")}
              </Col>
              <Col md="9" style={{wordBreak: 'break-word'}}>
                <a target="_blank"  rel="noopener noreferrer" style={{fontWeight: 'bold'}} href={prefixCheck(data.websiteurl)}>{data.websiteurl}</a>
              </Col>
              <Col md="3" className="mb-1">
                {t("last_contribution_date")}
              </Col>
              <Col md="9" className="mb-1">
                  {convertDate(data.all_contributions?.[0]?.["pub_date"])}
              </Col>
              <Col md="3" className="mb-1">
                {t("remarks")}
              </Col>
              <Col md="9" className="mb-1" dangerouslySetInnerHTML={{__html: data.remarks?data.remarks.replace(/\n/g,"<br>"):""}}></Col>
            </Row>
            <br></br>
            <Row>
              <Col md="3" className="mb-1">
                {t("organization")}
              </Col>
              <Col md="9" className="mb-1">
                {data.name}
              </Col>
              <Col md="3" className="mb-1">
                {t("address")}
              </Col>
              <Col md="9" className="mb-1">
                {data.addressformatted}
              </Col>
              <Col md="3" className="mb-1">
                {t("contact")}
              </Col>
              <Col md="9">
                <a href={prefixMailto(data.email)}>{data.email}</a>
              </Col>
            </Row>
          </Container>
        ):<div className="text-center"><Spinner animation="border" variant="primary" /></div>}
      </Modal.Body>
    </Modal>
  );
};

export interface IActiveRegisterModal {
  publicationname?: string;
  publicationtypeid?: string;
  countryid?: string;
  name?: string;
  websiteurl?: string;
  remarks?: string;
  email?: string;
  addressformatted?: string;
  all_contributions?: IActiveRegisterContribution[];
}

export default RegistersModal;
